class ProductImages extends HTMLElement {
  constructor() {
    super();

    if (document.body.classList.contains('template-product')) {
      var elem = this.querySelector('ul');
      var flkty = new Flickity( elem, {
        cellAlign: 'left',
        pageDots: false,
        adaptiveHeight: false,
        fade: true,
        imagesLoaded: true,
        wrapAround: true
      });
    }
  }
}

customElements.define('product-images', ProductImages);

class ProductThumbs extends HTMLElement {
  constructor() {
    super();

    if (document.body.classList.contains('template-product')) {
      var elem = this.querySelector('ul');
      var mainImg = document.querySelector('product-images ul');
      var flkty = new Flickity( elem, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        asNavFor: mainImg,
        prevNextButtons: false,
        adaptiveHeight: false,
        imagesLoaded: true
      });
    }
  }
}

customElements.define('product-thumbs', ProductThumbs);